import ExpoClipboard from './ExpoClipboard';
export default ExpoClipboard;
